import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : "/api";

export default function WaitlistForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || status === "loading") return;

    setStatus("loading");
    try {
      await axios.post(`${API}/waitlist`, { email });
      setStatus("success");
      setEmail("");
      toast.success("You are on the list. We will be in touch.");
    } catch (err) {
      if (err.response?.status === 409) {
        toast.info("You are already on the waitlist.");
        setStatus("idle");
      } else {
        setStatus("error");
        toast.error("Something went wrong. Try again.");
        setTimeout(() => setStatus("idle"), 2000);
      }
    }
  };

  return (
    <div className={compact ? "max-w-md" : "max-w-md mx-auto"}>
      {status === "success" ? (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="flex items-center justify-center gap-3 py-4"
          data-testid="waitlist-success"
        >
          <div className="w-8 h-8 rounded-full bg-pragti-green/10 flex items-center justify-center">
            <Check size={16} strokeWidth={2} className="text-pragti-green" />
          </div>
          <span className="font-body text-sm text-pragti-green font-medium">
            You are in. We will reach out soon.
          </span>
        </motion.div>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3"
          data-testid="waitlist-form"
        >
          <div className="flex-1 relative">
            <input
              id="waitlist-email-input"
              data-testid="waitlist-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              className="w-full bg-transparent border-b border-pragti-text/30 focus:border-pragti-accent rounded-none px-0 py-3 text-pragti-text placeholder:text-pragti-text-secondary/50 font-body text-sm outline-none transition-colors duration-300"
            />
          </div>
          <button
            data-testid="waitlist-submit-button"
            type="submit"
            disabled={status === "loading"}
            className="group flex items-center justify-center gap-2 px-8 py-3 rounded-full border border-pragti-text text-pragti-text text-sm font-body font-medium hover:bg-pragti-accent hover:text-pragti-bg hover:border-pragti-accent transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
          >
            {status === "loading" ? (
              <Loader2 size={16} strokeWidth={1.5} className="animate-spin" />
            ) : (
              <>
                Join Waitlist
                <ArrowRight
                  size={14}
                  strokeWidth={1.5}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </>
            )}
          </button>
        </form>
      )}

      <p className="font-mono text-[11px] tracking-wide text-pragti-text-secondary/60 mt-4">
        Early access only. No spam.
      </p>
    </div>
  );
}
